import { useCallback, useEffect, useRef, useState } from "react";
import { Bell } from "../../icons";
import useInappManager from "@fyno/react-hooks";
import { getDayDifference } from "../../helpers";
import { useNavigate } from "react-router-dom";
import { FynoProps, NotificationType, RedirectType } from "../types";

const Notification = ({ fynoProp }: { fynoProp: FynoProps }) => {
  const navigate = useNavigate();
  const [hidden, setHidden] = useState<boolean>(true);
  const [isAllowHideOnBackClick, setIsAllowHideOnBackClick] =
    useState<boolean>(true);
  const [count, setCount] = useState<number>(1);
  const [isEnd, setIsEnd] = useState<boolean>(false);
  const [openNotification, setopenNotification] = useState(false);
  const { data = { list: [], count: 0, unreadCount: 0 }, handlers } =
    useInappManager(fynoProp) || {};
  console.log(data);
  const { handleMarkAsRead, loadMoreNotifications, handleMarkAllAsRead } =
    handlers;
  const onClickNotification = (
    notification: NotificationType,
    redirectDetails: RedirectType,
  ) => {
    if (redirectDetails.page === "profile") {
      navigate(`/home/user/${redirectDetails.props.user_id}`);
    }
    if (redirectDetails.page === "post") {
      navigate(`/home/activity/${redirectDetails.props.post_id}`);
    }

    setHidden(true);
    handleMarkAsRead(notification);
  };

  const observerRef = useRef<IntersectionObserver>();

  const lastPostElementRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (data.list.length === 0 || isEnd) return;
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !isEnd) {
          if (count < Math.ceil(data.count / data.list.length)) {
            setCount((prev) => prev + 1);
          } else {
            setIsEnd(true);
          }
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [isEnd, data],
  );

  useEffect(() => {
    setopenNotification(false);
  }, [data.unreadCount]);

  useEffect(() => {
    if (count > 1) {
      loadMoreNotifications(count, "all");
    }
  }, [count]);

  useEffect(() => {
    document.addEventListener("mousedown", handleHidewhenClickedOutside);
    return () => {
      document.removeEventListener("mousedown", handleHidewhenClickedOutside);
    };
  }, [isAllowHideOnBackClick]);

  const handleHidewhenClickedOutside = (e: any) => {
    const popOverElement = ["bell-icon-img"];

    if (!isAllowHideOnBackClick) {
      return;
    }
    if (!popOverElement.includes(e.target.id)) setHidden(true);
  };

  return (
    <div id="bell-icon-img">
      <div
        id="bell-icon-img"
        onClick={() => {
          setHidden(!hidden);
          setopenNotification(true);
          handleMarkAllAsRead();
        }}
        className="cursor-pointer w-full"
      >
        <Bell id="bell-icon-img" />
      </div>
      {!openNotification && data?.unreadCount > 0 && (
        <div className="rounded-full">
          <div
            className={`${
              data?.unreadCount === 0 ? "hidden" : "block"
            } -top-1 absolute bg-[#ff261a] rounded-full border-2 border-white -right-1 text-white text-xs w-5 h-5 flex justify-center items-center`}
          >
            {data?.unreadCount}
          </div>
        </div>
      )}

      {!hidden && (
        <div
          className="absolute right-0 top-[2.5rem] bg-white rounded-[10px] shadow-notification-card min-w-[600px] max-h-[550px]"
          onMouseEnter={() => setIsAllowHideOnBackClick(false)}
          onMouseLeave={() => setIsAllowHideOnBackClick(true)}
        >
          <div>
            <div className="text-[20px] font-[700] p-[18px]">Notifications</div>
            <div className="overflow-y-scroll h-[450px]">
              {data?.list?.map((item: any, index: number) => {
                if (item?.notification_content?.additional_data?.digest === "")
                  return null;
                interface NotificationContentType {
                  head: Array<{
                    left_image: { image_url: string; redirect_to: any };
                    right_image?: { image_url: string; redirect_to?: any };
                    message?: Array<{
                      type: string;
                      text?: string;
                      redirect_to?: {
                        page: string;
                        props: any;
                      };
                    }>;
                    right_button?: {
                      text: string;
                      link: string;
                      type?: string;
                      display?: string;
                      redirect_to?: any;
                    };
                  }>;
                  count: number;
                }
                let notificationContent: NotificationContentType;
                try {
                  const parsedContent = JSON.parse(
                    item?.notification_content?.additional_data?.digest || "{}",
                  ) as Partial<NotificationContentType>;
                  notificationContent = {
                    head: Array.isArray(parsedContent.head)
                      ? parsedContent.head
                      : [],
                    count:
                      typeof parsedContent.count === "number"
                        ? parsedContent.count
                        : 0,
                  };
                } catch (error) {
                  console.error("Error parsing notification digest:", error);
                  return null;
                }
                return (
                  <div
                    key={index}
                    className={`flex justify-center ${!item.isRead && "bg-[#FAF5E5]"} items-center pl-[18px] pr-[18px] pt-[12px] pb-[12px] w-full border-b border-[#EBEBEB]`}
                  >
                    <div
                      className="flex items-start cursor-pointer"
                      onClick={() =>
                        onClickNotification(
                          item,
                          notificationContent?.head[0]?.left_image?.redirect_to,
                        )
                      }
                    >
                      <img
                        alt=""
                        src={
                          notificationContent?.head[0]?.left_image?.image_url
                        }
                        className="rounded-[10px] h-[45px] w-[50px] object-cover"
                      />
                    </div>
                    <div className="flex-col ml-[16px] w-full">
                      <div className="flex justify-between w-full">
                        <div className="flex justify-center items-center text-[14px] font-Inter text-[#404040]">
                          <div className="flex">
                            {(notificationContent?.head[0]?.message || []).map(
                              (remaningMessage: any, index: number) => {
                                return remaningMessage.type === "redirect" ? (
                                  remaningMessage.redirect_to.page ===
                                    "profile" && (
                                    <div
                                      key={index}
                                      className="ml-[2px] font-bold hover:cursor-pointer"
                                      onClick={() =>
                                        onClickNotification(
                                          item,
                                          remaningMessage.redirect_to,
                                        )
                                      }
                                    >
                                      {remaningMessage?.display}
                                    </div>
                                  )
                                ) : (
                                  <div
                                    key={index}
                                    onClick={() =>
                                      onClickNotification(
                                        item,
                                        notificationContent?.head[0]
                                          ?.right_image?.redirect_to,
                                      )
                                    }
                                    className="ml-[5px] hover:cursor-pointer"
                                  >
                                    {notificationContent?.count == 1
                                      ? remaningMessage?.display
                                      : ` and ${notificationContent?.count - 1} others ` +
                                        remaningMessage?.display}
                                  </div>
                                );
                              },
                            )}
                          </div>
                          <div className="text-[#999] text-[14px] font-Inter ml-[6px]">
                            {getDayDifference(item.createdAt)}
                          </div>
                        </div>
                        {notificationContent?.head[0]?.right_image
                          ?.image_url !== "" && (
                          <div
                            className="flex items-start"
                            onClick={() =>
                              onClickNotification(
                                item,
                                notificationContent?.head[0]?.right_image
                                  ?.redirect_to,
                              )
                            }
                          >
                            <img
                              alt=""
                              src={
                                notificationContent?.head[0]?.right_image
                                  ?.image_url
                              }
                              className="rounded-[10px] h-[45px] w-[45px]"
                            />
                          </div>
                        )}
                        {notificationContent?.head[0]?.right_button?.type &&
                          (notificationContent?.head[0]?.right_button
                            ?.display === "Follow" ? (
                            <div
                              className="bg-[#007AFF] pt-[4px] pb-[4px] pl-[12px] pr-[12px] text-white rounded-[35px] font-[400] text-[13px] cursor-pointer"
                              onClick={() =>
                                onClickNotification(
                                  item,
                                  notificationContent?.head[0]?.right_button
                                    ?.redirect_to,
                                )
                              }
                            >
                              {
                                notificationContent?.head[0]?.right_button
                                  ?.display
                              }
                            </div>
                          ) : (
                            <div
                              className="pt-[4px] pb-[4px] pl-[12px] pr-[12px] text-[#007AFF] rounded-[35px] font-[400] text-[13px] border border-[#007AFF] cursor-pointer"
                              onClick={() =>
                                onClickNotification(
                                  item,
                                  notificationContent?.head[0]?.right_button
                                    ?.redirect_to,
                                )
                              }
                            >
                              {
                                notificationContent?.head[0]?.right_button
                                  ?.display
                              }
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                );
              })}
              {data?.list?.length === 0 && (
                <div className="flex flex-col justify-center h-full items-center">
                  <div>
                    <img
                      src="/assets/logo/speaker-icon.svg"
                      height={"150px"}
                      width={"150px"}
                      alt="whatsapp"
                    />
                  </div>
                  <div className="text-[20px] font-[500]">
                    No New Notifications
                  </div>
                  <div className="text-[#6F6F6F] font-[400] text-[14px]">
                    Stay updated for the new updates
                  </div>
                </div>
              )}
              <div ref={lastPostElementRef}></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notification;
